__webpack_require__.p = "https://misothings.com/same-but-different/";